import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import {
  addCallRecords,
  getMissedCallCount,
  ringCentralSipInfo,
  ringCentralAllocateExtension,
  ringCentralReleaseExtension,
  ringCentralExtensionHeartbeat,
  ringCentralIncomingCaller,
  getTwilioUserToken,
  getUsersById,
  getVideoCallToken,
} from "../api/apiManager";
// import { Device } from "@twilio/voice-sdk";
import { Device } from "@twilio/voice-sdk";
import {
  setCaller,
  setClearIncomingCall,
  setAudioCallStart,
  setShowChatSectionDuringCall,
  setCallRunningInBG,
  setCallerName,
  setContactImage,
  setIsReceiveMuted,
  setIsSendingRoomData,
  setDialingNumber,
  setIsOnCall,
  setCallOpen,
  setDialOpen,
  setIsMuted,
  setMissedCallCount,
  setMissedCallParticipantId,
  setUserBusyModel,
} from "../store/slice/CallSlice";
import { setCallHistory } from "../store/slice/ChatSlice";
import webRtcCallService, {
  WEBRTC_STATUS,
} from "../webrtc/webRtcCallService";
import { useDispatch } from "react-redux";
import {
  GroupCall,
  newCallLogs,
  // SendCallAccept,
  SendCallConversationId,
  SendReconnectingStatus,
  startGroupCall,
} from "../signalRService/signalRService";
import { useNavigate } from "react-router-dom";
import { BgCallPopupContext } from "./BgCallPopupContext";
import { connect, createLocalAudioTrack } from "twilio-video";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import Video from "twilio-video";
import outgoingRingtone from "../../../assets/audio/intercom.mp3";
import { is } from "date-fns/locale";
import groupCallEndRingtone from "../../../assets/audio/CallEndSound.mp3";
// import { ringCentralWebPhoneService } from "../ringcentral/ringCentralWebPhoneService";
// import ringCentralWebPhoneService from "../ringcentral/ringCentralWebPhoneService";
import ringCentralWebPhoneService, {
  CALL_STATUS,
} from "../ringcentral/ringCentralWebPhoneService";
import { CALL_PROVIDER_EVENT } from "../callProvider";

const TwilioContext = createContext();
export const TwilioProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const audioRef = React.useRef(null);
  const joinedParticipantIdsRef = useRef(new Set());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginUserName = localStorage.getItem("username");
  const user_id = localStorage.getItem("user_id");
  const getSelectedCallProvider = () =>
    localStorage.getItem("selectedCallProvider") || "RingCentral";
  const [activeConnection, setActiveConnection] = React.useState(false);
  const [callStatus, setCallStatus] = React.useState("");
  const [callEnded, setCallEnded] = React.useState(false);
  const [callStartTime, setCallStartTime] = React.useState(null);
  const [userOffline, setUserOffline] = React.useState(false);
  const [callAccepted, setCallAccepted] = React.useState(false);
  const [incomingCall, setIncomingCall] = React.useState(false);
  const [device, setDevice] = React.useState(null);
  const [callLogsCallId, setCallLogsCallId] = React.useState(null);
  const isInitiatorGCall = JSON.parse(localStorage.getItem("isInitiatorGCall"));
  const [groupRoom, setGroupRoom] = React.useState(null);
  const [gCallParticipants, setGCallParticipants] = React.useState([]);
  const [mainParticipant, setMainParticipant] = React.useState(null);
  const [groupName, setGroupName] = React.useState("");
  const { setIsCallActive } = BgCallPopupContext();
  const [callDuration, setCallDuration] = React.useState(0);
  const [remoteMutedData, setRemoteMutedData] = React.useState(null);
  const [previousMuteStatus, setPreviousMuteStatus] = React.useState(null);
  const [chat_Id, setChat_Id] = React.useState(null);
  const [allowedUserIds, setAllowedUserIds] = React.useState([]);
  const [groupPicPath, setGroupPicPath] = React.useState("");
  const [groupConversationId, setGroupConversationId] = React.useState(null);
  const [dataTrack, setDataTrack] = React.useState(null);
  const [reconnectingParticipants, setReconnectingParticipants] =
    React.useState([]);
  const [isScreenShareDisabled, setIsScreenShareDisabled] =
    React.useState(false);
  const [leftParticipants, setLeftParticipants] = React.useState([]);
  const [participantJoinStatus, setParticipantJoinStatus] = React.useState({});
  const [isGroupCallMuted, setIsGroupCallMuted] = React.useState(false);
  const [isGroupCallRingtone, setIsGroupCallRingtone] = React.useState(false);
  const [activeGroupRooms, setActiveGroupRooms] = React.useState({});
  const [reconnectingStatus, setReconnectingStatus] = React.useState(false);
  const [noDeviceModal, setNoDeviceModal] = React.useState({
    isOpen: false,
    title: "",
    message: "",
    buttonText: "",
  });
  const dataTrackRef = useRef(null);
  const ringAudioRef = useRef(null);
  let callRecordTimeout;
  const callRecordAdded = useRef(false);
  // RingCentral outbound caller ID (the account's FROM_NUMBER), captured at SIP init.
  const ringCentralFromNumberRef = useRef(null);
  // RingCentral call-record tracking (refs avoid stale closures in the status subscription).
  const ringCentralDialedNumberRef = useRef(null);
  const ringCentralCallStartRef = useRef(null);
  const ringCentralSavedRef = useRef(false);
  // Direction of the current RC call, used when writing the call-log record:
  // "OUTGOING" for dials, "INCOMING" for answered inbound calls.
  const ringCentralDirectionRef = useRef("OUTGOING");
  // RingCentral softphone re-registration recovery (Fix A): throttle + the time
  // the tab was last hidden, so we only re-register after a real suspend.
  const rcLastReconnectRef = useRef(0);
  const rcHiddenSinceRef = useRef(0);
  // Outbound extension pool: which extension this browser is currently
  // registered to, and the heartbeat that keeps the pool slot from being
  // reclaimed mid-call.
  const rcCurrentExtensionRef = useRef(null);
  const rcHeartbeatRef = useRef(null);

  const cleanupSingleCallState = useCallback(() => {
    setActiveConnection(null);
    setIncomingCall(null);
    setCallAccepted(false);
    setIsCallActive(false);
    dispatch(setClearIncomingCall(true));
    dispatch(setAudioCallStart(false));
    dispatch(setShowChatSectionDuringCall(false));
    dispatch(setCallRunningInBG(false));
    dispatch(setIsReceiveMuted([]));
    dispatch(setIsMuted(false));
    setCallDuration(0);

    // Outbound extension pool: on any RingCentral call teardown, stop the
    // heartbeat, deregister the softphone from the pooled extension, and release
    // the slot back to the pool so another user can take it.
    if (getSelectedCallProvider() === "RingCentral") {
      if (rcHeartbeatRef.current) {
        clearInterval(rcHeartbeatRef.current);
        rcHeartbeatRef.current = null;
      }
      ringCentralReleaseExtension(user_id);
      ringCentralWebPhoneService.reset();
      rcCurrentExtensionRef.current = null;
      window.__ringCentralReady = false;
    }
  }, [dispatch, setIsCallActive]);

  // Saves a RingCentral outbound call into the same Call/CallParticipant tables the
  // call-logs UI reads from. Called once per call when it reaches a terminal state
  // (covers both user-initiated and recipient-initiated hangups). Uses refs so it is
  // immune to stale closures inside the status subscription.
  const saveRingCentralCallRecord = useCallback(async () => {
    if (ringCentralSavedRef.current) return;
    const to = ringCentralDialedNumberRef.current;
    if (!to) return;
    ringCentralSavedRef.current = true;

    const start = ringCentralCallStartRef.current;
    const durationSec = start
      ? Math.max(0, Math.round((Date.now() - start.getTime()) / 1000))
      : 0;
    const fmt = (d) =>
      dayjs(d).format("HH:mm:ss.") +
      dayjs(d).millisecond().toString().padEnd(7, "0");
    const startStr = start ? fmt(start) : "00:00:00.0000000";

    const payload = {
      CallId: 0,
      callType: "Single",
      callTitle: to,
      CreatedBy: parseInt(user_id),
      STARTTIME: durationSec > 0 ? startStr : "00:00:00.0000000",
      ENDTIME: durationSec > 0 ? fmt(new Date()) : "00:00:00.0000000",
      CALLSTATUS: durationSec > 0 ? "Completed" : "Busy",
      DURATION: durationSec,
      callParticipants: [
        {
          userId: parseInt(user_id),
          joinedAt: startStr,
          // Inbound answered -> INCOMING; inbound never answered -> MISSED;
          // outbound (answered or not) -> OUTGOING.
          callResponse:
            ringCentralDirectionRef.current === "INCOMING"
              ? durationSec > 0
                ? "INCOMING"
                : "MISSED"
              : "OUTGOING",
          ExternalPersonContactNo: to,
          CreatedBy: parseInt(user_id),
          // A missed inbound call is unseen (drives the missed-call indicator).
          IsSeen: !(
            ringCentralDirectionRef.current === "INCOMING" && durationSec === 0
          ),
        },
      ],
    };

    try {
      const resp = await addCallRecords(payload);
      const result = resp?.data?.result;
      const callId = result?.callId;
      if (callId) {
        // Notify other participants (no-op for external calls with null conversation).
        newCallLogs(callId);
        // Refresh THIS caller's call-log list directly. External calls have a null
        // ConversationId, so the server-side CallHistory broadcast never reaches the
        // caller — dispatching to Redux triggers CallSection's real-time refresh.
        const participants = result?.callParticipants || [];
        const rep =
          participants.find((p) => String(p.userId) === String(user_id)) ||
          participants[0];
        dispatch(
          setCallHistory([
            {
              callId: result.callId,
              callResponse: rep?.callResponse,
              createdDate: result.createdDate,
              duration: result.duration,
              callStatus: result.callStatus,
              createdBy: result.createdBy,
              callParticipantId: rep?.callParticipantId,
              callType: result.callType,
              participants: rep ? [rep] : [],
              conversationId: result.conversationId,
              startTime: result.startTime,
              endTime: result.endTime,
            },
          ]),
        );
      }
    } catch (err) {
      console.error("Failed to save RingCentral call record:", err);
    }
  }, [user_id, dispatch]);

  const initializeRingCentral = async () => {
    const response = await ringCentralSipInfo(user_id);

    if (!response || response.status !== 200) {
      const backendError =
        response?.data?.error ||
        response?.data?.message ||
        response?.data?.title ||
        `SIP info request failed with HTTP ${response?.status}`;
      throw new Error(backendError);
    }

    const payload = response.data;
    if (!payload?.sipInfo) {
      throw new Error("SIP info missing in RingCentral response");
    }

    // Caller ID for outbound calls is the RingCentral account FROM_NUMBER.
    ringCentralFromNumberRef.current = payload.fromNumber || null;
    if (payload.fromNumber) {
      localStorage.setItem("ringCentral_from_number", payload.fromNumber);
    }

    return ringCentralWebPhoneService.init({
      ...payload,
      appUserId: user_id,
    });
  };

  // Outbound pool: check out a free extension and register the softphone to it
  // just for this call. Throws "All lines busy" when the pool is exhausted.
  const initializeRingCentralOutbound = async () => {
    const response = await ringCentralAllocateExtension(user_id);
    if (!response || response.status !== 200 || !response.data?.sipInfo) {
      // 409 (pool exhausted) or any error -> no line available right now.
      throw new Error("All calling lines are busy. Please try again in a moment.");
    }

    const payload = response.data;
    // Caller ID stays the one shared number for every pool extension.
    ringCentralFromNumberRef.current = payload.fromNumber || null;
    if (payload.fromNumber) {
      localStorage.setItem("ringCentral_from_number", payload.fromNumber);
    }

    const allocatedExt = payload.extensionId || null;
    const alreadyOnThisExt =
      rcCurrentExtensionRef.current === allocatedExt &&
      ringCentralWebPhoneService.getState?.().isReady;

    // Re-register only if we're not already on the allocated extension.
    if (!alreadyOnThisExt) {
      await ringCentralWebPhoneService.reset();
      await ringCentralWebPhoneService.init({ ...payload, appUserId: user_id });
      rcCurrentExtensionRef.current = allocatedExt;
    }
    window.__ringCentralReady = true;
    return true;
  };

  // Ping the pool while a RingCentral call is active so the held extension isn't
  // reclaimed mid-call (calls can outlast the pool's stale-hold window).
  //
  // Safety net: before each ping, confirm the WebPhone still has a LIVE session.
  // If the call has ended but no terminal status reached cleanupSingleCallState()
  // (e.g. a terminal SDK state the dispose watcher didn't recognise), an
  // unconditional heartbeat would keep the pooled extension held for the life of
  // the tab and the server could never reclaim it (reclaim only fires once
  // heartbeats STOP). So a tick with no live session stops the heartbeat and
  // releases the slot instead of pinging.
  const startRcHeartbeat = () => {
    if (rcHeartbeatRef.current) clearInterval(rcHeartbeatRef.current);
    rcHeartbeatRef.current = setInterval(() => {
      if (!ringCentralWebPhoneService.hasLiveSession?.()) {
        clearInterval(rcHeartbeatRef.current);
        rcHeartbeatRef.current = null;
        ringCentralReleaseExtension(user_id);
        return;
      }
      ringCentralExtensionHeartbeat(user_id);
    }, 30000);
  };

  useEffect(() => {
    return ringCentralWebPhoneService.subscribe((event) => {
      if (!event) return;

      // Inbound PSTN call to the RingCentral number: surface the same
      // CallNotification popup the WebRTC/Twilio incoming calls use.
      if (event.type === "incoming") {
        // The SDK number is usable only if it's a real (+digits) number.
        const sdkNum =
          event.callerId && /^\+?\d{6,}$/.test(String(event.callerId))
            ? event.callerId
            : null;

        // Track this inbound call so the terminal-state save logs it correctly.
        ringCentralDirectionRef.current = "INCOMING";
        ringCentralDialedNumberRef.current = sdkNum; // the OTHER party (updated below if null)
        ringCentralSavedRef.current = false;
        ringCentralCallStartRef.current = null;
        setIncomingCall({
          ringcentral: true,
          callerId: sdkNum || "",
          parameters: { From: sdkNum || "" },
        });
        if (sdkNum) dispatch(setCaller(String(sdkNum)));

        // The WebPhone SDK doesn't reliably expose the caller number, so when it
        // didn't, ask the backend (RingCentral active-calls). The call shows as
        // an active inbound call there a moment after it starts ringing — retry
        // briefly until it appears.
        if (!sdkNum) {
          (async () => {
            for (let i = 0; i < 5; i++) {
              const res = await ringCentralIncomingCaller();
              const d = res?.data;
              // External caller -> phone number; internal caller -> name / "Ext NNN".
              const caller =
                d?.from ||
                d?.name ||
                (d?.extensionNumber ? `Ext ${d.extensionNumber}` : null);
              if (caller) {
                ringCentralDialedNumberRef.current = caller;
                setIncomingCall((prev) =>
                  prev && prev.ringcentral
                    ? { ...prev, callerId: caller, parameters: { From: caller } }
                    : prev,
                );
                dispatch(setCaller(String(caller)));
                return;
              }
              await new Promise((r) => setTimeout(r, 700));
            }
          })();
        }
        return;
      }
      if (event.type === "incoming-cancelled") {
        // Caller hung up (or we declined) before answering -> log a missed
        // inbound call (duration 0 -> "MISSED"), then clear the popup.
        saveRingCentralCallRecord();
        setIncomingCall(null);
        return;
      }

      if (event.type === "status") {
        switch (event.status) {
          case CALL_STATUS.CALLING:
            setCallStatus("Calling...");
            setCallAccepted(false);
            setCallDuration(0);
            // New OUTBOUND call starting — reset the save guard and timing.
            ringCentralDirectionRef.current = "OUTGOING";
            ringCentralSavedRef.current = false;
            ringCentralCallStartRef.current = null;
            break;

          case CALL_STATUS.TRYING:
            setCallStatus("Ringing...");
            setCallAccepted(false);
            setCallDuration(0);
            break;

          case CALL_STATUS.CONNECTED:
            setCallStatus("Connected");
            setCallDuration(0);
            setCallStartTime(new Date().toISOString());
            ringCentralCallStartRef.current = new Date();
            setCallAccepted(true);
            break;

          case CALL_STATUS.HOLD:
            setCallStatus("On Hold");
            break;

          case CALL_STATUS.DISCONNECTED:
          case CALL_STATUS.FAILED:
          case CALL_STATUS.BUSY:
          case CALL_STATUS.NO_ANSWER:
          case CALL_STATUS.DECLINED:
            // Save the call log before tearing down (covers user- and recipient-
            // initiated hangups). Guarded against double-save inside the function.
            saveRingCentralCallRecord();
            setCallAccepted(false);
            setCallDuration(0);
            // Show the actual outcome ("Call Ended" / "Failed" / "Busy" /
            // "No Answer" / "Call Declined") instead of leaving the previous
            // status on-screen.
            setCallStatus(event.status);
            setCallEnded(true);
            cleanupSingleCallState();
            // Surface a toast for calls that never connected (a normal end
            // after pickup — DISCONNECTED — needs none).
            if (event.status !== CALL_STATUS.DISCONNECTED) {
              const msg =
                event.status === CALL_STATUS.BUSY
                  ? "The number is busy. Please try again later."
                  : event.status === CALL_STATUS.NO_ANSWER
                    ? "No answer."
                    : event.status === CALL_STATUS.DECLINED
                      ? "Call declined."
                      : "Call could not be connected.";
              enqueueSnackbar(msg, {
                variant:
                  event.status === CALL_STATUS.FAILED ? "error" : "warning",
                autoHideDuration: 4000,
              });
            }
            setTimeout(() => {
              setCallStatus("");
              navigate("/chats");
            }, 1500);
            break;

          default:
            setCallStatus(event.status);
        }
      }
    });
  }, [cleanupSingleCallState, navigate, saveRingCentralCallRecord, dispatch]);

  // Native WebRTC in-app call: drive the UI from the engine's status + incoming events.
  useEffect(() => {
    return webRtcCallService.subscribe((event) => {
      if (!event) return;
      if (event.type === "incoming") {
        // Surface incoming call (CallNotification renders when incomingCall is set).
        setIncomingCall({
          webrtc: true,
          callId: event.callId,
          callerId: event.callerId,
          callType: event.callType,
        });
        dispatch(setCaller(String(event.callerId)));
        return;
      }
      if (event.type !== "status") return;
      switch (event.status) {
        case WEBRTC_STATUS.CALLING:
          setCallStatus("Calling...");
          break;
        case WEBRTC_STATUS.RINGING:
          setCallStatus("Ringing...");
          break;
        case WEBRTC_STATUS.CONNECTED:
          setCallStatus("Connected");
          setCallAccepted(true);
          setCallStartTime(new Date().toISOString());
          break;
        case WEBRTC_STATUS.BUSY:
          setCallStatus("User Busy");
          setCallEnded(true);
          cleanupSingleCallState();
          setIncomingCall(null);
          setTimeout(() => {
            setCallStatus("");
            navigate("/chats");
          }, 1500);
          break;
        case WEBRTC_STATUS.NO_ANSWER:
        case WEBRTC_STATUS.FAILED:
        case WEBRTC_STATUS.DISCONNECTED:
          setCallAccepted(false);
          setCallEnded(true);
          // Backend already wrote the Call/CallParticipant record (ChatHub.SendOffer);
          // nudge the call-logs list to silently re-fetch so it appears without a refresh.
          dispatch(
            setCallHistory([
              { callId: webRtcCallService.getState()?.callId ?? null },
            ]),
          );
          cleanupSingleCallState();
          setIncomingCall(null);
          setTimeout(() => {
            setCallStatus("");
            navigate("/chats");
          }, 1200);
          break;
        default:
          setCallStatus(event.status);
      }
    });
  }, [cleanupSingleCallState, navigate, dispatch]);

  const openNoDeviceModal = ({ title, message, buttonText }) => {
    setNoDeviceModal({
      isOpen: true,
      title,
      message,
      buttonText,
    });
  };

  const closeNoDeviceModal = () => {
    setNoDeviceModal((prev) => ({ ...prev, isOpen: false }));
  };

  // region Initialize the Twilio connection
  // region fetch Twailio Token
  const fetchTwilioToken = async (user_id) => {
    try {
      const response = await getTwilioUserToken(user_id);
      const token = response.data.token;

      // Destroy old device if exists
      if (device) {
        try {
          await device.destroy();
        } catch (err) {
          console.error("Error destroying old device:", err);
        }
      }

      // Create new Device
      const newDevice = new Device(token, {
        codecPreferences: ["opus", "pcmu"],
        enableRingingState: true,
        debug: true,
        logLevel: "debug",
        edge: "singapore",
      });

      // --- Error Handler ---
      const handleError = (error) => {
        console.error("Twilio.Device Error:", error.message);
        if (error.message.includes("Requested device not found")) {
          openNoDeviceModal({
            title: "Device Error",
            message: "Microphone not found, kindly connect your device.",
            buttonText: "Close",
          });
        }
        setUserOffline(false);
      };

      // --- Incoming Call Handler ---
      const handleIncoming = (conn) => {
        // Set incoming state so UI popup can appear
        setIncomingCall(conn);
        dispatch(setCaller(conn.parameters.From));

        // Accept handler
        const acceptCall = () => {
          conn.accept();
        };

        const rejectCall = () => {
          conn.reject();
          setIncomingCall(null);
        };

        window.acceptCall = acceptCall;
        window.rejectCall = rejectCall;
        // When call actually connects
        conn.on("accept", () => {
          setCallAccepted(true);
          setIncomingCall(null);
          setCallDuration(0);
          setActiveConnection(conn);
          setIsCallActive(true);
          dispatch(setAudioCallStart(true));
          navigate("/chats");
        });

        // When remote party disconnects
        conn.on("disconnect", () => {
          setCallEnded(true);
          setActiveConnection(null);
          setIncomingCall(null);
          setCallAccepted(false);
          setIsCallActive(false);
          dispatch(setAudioCallStart(false));
        });
      };

      // --- Disconnect Handler ---
      const handleDisconnect = async (conn) => {
        setCallEnded(true);
        setActiveConnection(null);
        setIncomingCall(null);
        setCallAccepted(false);
        setIsCallActive(false);
        dispatch(setAudioCallStart(false));
        navigate("/chats");
      };

      // --- Device Event Handlers ---
      newDevice.on("ready", () => {
        console.log("Twilio Device ready!");
      });

      newDevice.on("registered", () => {
        console.log("Device registered successfully>>>");
      });

      newDevice.on("unregistered", () => console.log("Device unregistered>>>"));
      newDevice.on("error", handleError);
      newDevice.on("incoming", handleIncoming);
      newDevice.on("disconnect", handleDisconnect);

      await newDevice.register();
      // Finally set it as current device
      setDevice(newDevice);
    } catch (error) {
      console.error("Error fetching Twilio token:", error);
    }
  };

  useEffect(() => {
    if (user_id) {
      // Fetch token initially
      if (getSelectedCallProvider() === "Twilio") {
        fetchTwilioToken(user_id);
      }
      // Set interval for token refresh every 30 minutes
      const interval = setInterval(
        () => {
          if (getSelectedCallProvider() === "Twilio") {
            fetchTwilioToken(user_id);
          }
        },
        30 * 60 * 1000,
      );

      return () => clearInterval(interval);
    }
  }, [user_id]);

  // Initialize the Twilio Device when the provider is switched to Twilio at
  // RUNTIME. The mount effect above only inits Twilio if it's the selected
  // provider at load; since the default is RingCentral, switching to Twilio later
  // (Settings dialog, or another client via the SignalR broadcast) wouldn't
  // create the Device -> "Device not ready" on the next dial. Listen for the
  // callProviderChanged event and (re)fetch the token/Device when it's Twilio.
  useEffect(() => {
    if (!user_id) return;
    const onProviderChange = (e) => {
      const provider = e?.detail || getSelectedCallProvider();
      if (provider === "Twilio") {
        fetchTwilioToken(user_id);
      }
    };
    window.addEventListener(CALL_PROVIDER_EVENT, onProviderChange);
    return () =>
      window.removeEventListener(CALL_PROVIDER_EVENT, onProviderChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  // DISABLED for the outbound-first extension-pool rollout.
  // This used to register the softphone to the single shared extension (108) on
  // app load so inbound calls rang. With the pool model a browser registers to a
  // checked-out extension only when dialing (see initializeRingCentralOutbound),
  // so we no longer pre-register here. Pooled INBOUND ("Go Online") will
  // re-enable a load-time registration later.
  // useEffect(() => {
  //   if (!user_id) return;
  //   if (getSelectedCallProvider() !== "RingCentral") return;
  //   let cancelled = false;
  //   (async () => {
  //     try {
  //       if (!window.__ringCentralReady) {
  //         await initializeRingCentral();
  //         if (!cancelled) window.__ringCentralReady = true;
  //       }
  //     } catch (e) {
  //       console.error("RingCentral init (for inbound) failed:", e);
  //     }
  //   })();
  //   return () => {
  //     cancelled = true;
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user_id]);

  // Fix A: re-register the RingCentral softphone after the SIP/WebSocket
  // connection is likely to have dropped (network change, PC sleep, or a tab
  // suspended in the background). When that happens the softphone silently
  // un-registers, so a caller hears ringback but the app never gets the
  // inboundCall event. Re-registering (same stable instanceId => replaces, not
  // duplicates) restores inbound. Guards: RingCentral only, never during a live
  // call, and throttled so quick tab switches don't churn the registration.
  const reconnectRingCentral = async (reason) => {
    if (!user_id) return;
    if (getSelectedCallProvider() !== "RingCentral") return;
    if (ringCentralWebPhoneService.isOnCall?.()) return;
    const now = Date.now();
    if (now - (rcLastReconnectRef.current || 0) < 15000) return;
    rcLastReconnectRef.current = now;
    try {
      await ringCentralWebPhoneService.reset();
      window.__ringCentralReady = false;
      await initializeRingCentral();
      window.__ringCentralReady = true;
      // eslint-disable-next-line no-console
      console.log(`[RC] softphone re-registered (${reason})`);
    } catch (e) {
      window.__ringCentralReady = false;
      console.error("[RC] re-register failed:", e);
    }
  };

  // Toggle for the inbound-registration recovery. OFF during the outbound-first
  // pool rollout (the softphone is only registered during an outbound call, so
  // there's no idle inbound registration to keep alive). Flip on with pooled
  // inbound ("Go Online").
  const ENABLE_RC_INBOUND_RECOVERY = false;
  useEffect(() => {
    if (!ENABLE_RC_INBOUND_RECOVERY) return;
    if (!user_id) return;
    if (getSelectedCallProvider() !== "RingCentral") return;

    const onVisibility = () => {
      if (document.visibilityState === "hidden") {
        rcHiddenSinceRef.current = Date.now();
        return;
      }
      // Only re-register if the tab was hidden long enough to have been
      // suspended (quick tab switches don't drop the connection).
      const hiddenFor = Date.now() - (rcHiddenSinceRef.current || 0);
      if (rcHiddenSinceRef.current && hiddenFor > 30000) {
        reconnectRingCentral("tab-refocus");
      }
    };
    const onOnline = () => reconnectRingCentral("network-online");

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("online", onOnline);
    // Safety-net keep-alive: catches a silently-dead SIP WebSocket that didn't
    // fire an offline/visibility event. Only re-registers when the connection is
    // POSITIVELY closed (isConnectionAlive() === false) so a healthy phone is
    // never needlessly churned (which could drop a call during the gap).
    const keepAlive = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      if (ringCentralWebPhoneService.isOnCall?.()) return;
      if (ringCentralWebPhoneService.isConnectionAlive?.() === false) {
        reconnectRingCentral("keep-alive-dead-socket");
      }
    }, 60 * 1000);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("online", onOnline);
      clearInterval(keepAlive);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  // Get Missed Call Count

  const getMissedCallCountData = async (userId) => {
    const resp = await getMissedCallCount(userId);
    if (resp?.status == 200) {
      dispatch(setMissedCallCount(resp?.data?.count));
      dispatch(
        setMissedCallParticipantId(
          resp?.data?.result
            ?.map((data) => data?.cp?.callParticipantId)
            ?.toString(),
        ),
      );
    }
  };

  useEffect(() => {
    if (callEnded) {
      setTimeout(() => {
        getMissedCallCountData(user_id);
      }, 1000);
    }
  }, [callEnded]);

  // region handleDial
  const handleDial = async (
    to,
    callerName,
    direction,
    contactName,
    contactImage,
    chat_Id,
    lastSeenRealTime,
    isUserOnline,
    userID,
  ) => {
    setChat_Id(chat_Id);
    dispatch(setCallerName(contactName));
    dispatch(setContactImage(contactImage));
    if (!isUserOnline && lastSeenRealTime) {
      // openNoDeviceModal({
      //   title: "User Status",
      //   message: `${contactName} is offline. Please try again later.`,
      //   buttonText: "Dismiss",
      // });
      // // return;
      setUserOffline(true);
      return;
    }
    dispatch(setAudioCallStart(true));
    setCallDuration(0);
    try {
      // Native WebRTC 1:1 in-app audio call. Signaling rides on SignalR/ChatHub;
      // call status + teardown are driven by the webRtcCallService subscription below.
      setActiveConnection({ webrtc: true });
      setCallStatus("Calling...");
      setIsCallActive(true);
      // Tell the callee which chat the call belongs to (UI context).
      if (chat_Id) SendCallConversationId(parseInt(chat_Id), parseInt(to));
      await webRtcCallService.startCall({
        callerId: userID || user_id,
        calleeUserId: to,
        chatId: chat_Id,
        callType: "Audio",
      });
    } catch (err) {
      console.error("WebRTC in-app call failed:", err);
      cleanupSingleCallState();
      setCallStatus("Failed");
      setCallEnded(true);
    }
  };

  useEffect(() => {
    let timer;
    if (callStatus === "Connected") {
      setCallStartTime(new Date().toISOString());
      timer = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [callStatus]);

  // For Outbound Calling Function is here

  const handleDialForOutboundCall = async (
    to,
    callerName,
    direction,
    value,
  ) => {
    const provider = getSelectedCallProvider();

    // This browser can only run one softphone session at a time. If a call is
    // already live, the old code silently no-op'd the new dial (looked like
    // "nothing happened") and clobbered the active call's status. Tell the user
    // and leave the current call untouched.
    if (provider === "RingCentral" && ringCentralWebPhoneService.isOnCall?.()) {
      enqueueSnackbar(
        "You're already on a call. Please end it before starting a new one.",
        { variant: "warning", autoHideDuration: 4000 },
      );
      return;
    }

    // Fresh dial: clear any stale status/ended flags left by a previous attempt
    // (e.g. a prior "All lines busy" / "Failed") so they don't linger on-screen
    // or show up "one call behind" on the next dial.
    setCallEnded(false);
    setCallStatus("");

    // For RingCentral, reserve a pool line and register the softphone BEFORE any
    // call UI opens. If every line is busy (409) we show a message instead of
    // flashing the call screen open then closed.
    if (provider === "RingCentral") {
      try {
        await initializeRingCentralOutbound();
      } catch (error) {
        console.error("RingCentral line reservation failed:", error);
        const busy = String(error?.message || "").toLowerCase().includes("busy");
        // No call UI has opened yet — just surface the message and stop.
        cleanupSingleCallState();
        setCallStatus("");
        enqueueSnackbar(
          busy
            ? "All lines are busy. Please wait for a line to free up and try again."
            : "Call failed. Please try again.",
          { variant: busy ? "warning" : "error", autoHideDuration: 5000 },
        );
        return;
      }
    }

    if (value) {
      dispatch(setDialingNumber(value));
    }

    dispatch(setAudioCallStart(true));

    // =========================
    // RINGCENTRAL FLOW
    // =========================
    if (provider === "RingCentral") {
      try {
        setCallDuration(0);

        // Line already reserved + softphone registered above; go straight to dial.
        dispatch(setDialOpen(false));
        dispatch(setCallOpen(false));

        setCallStatus("Calling...");
        setIsCallActive(true);

        // Track the dialed number for the call-log record saved when the call ends.
        ringCentralDirectionRef.current = "OUTGOING";
        ringCentralDialedNumberRef.current = to;
        ringCentralSavedRef.current = false;
        ringCentralCallStartRef.current = null;

        // Do NOT pass an explicit caller ID. RingCentral rejects a caller ID it
        // doesn't consider permitted for the extension and then falls back to the
        // extension's own number (ignoring the portal setting). By omitting it,
        // RingCentral uses each extension's configured Outbound Caller ID — which
        // you set to the main company number in the Admin Portal.
        const connection = await ringCentralWebPhoneService.call(to);

        // Keep the pooled extension alive for the duration of the call.
        startRcHeartbeat();

        setActiveConnection(connection);
        return;
      } catch (error) {
        console.error("RingCentral outbound call failed:", error);
        // The line was already reserved above, so this is a dial/connection
        // failure rather than a busy pool.
        cleanupSingleCallState();
        setCallStatus("Failed");
        setCallEnded(true);
        enqueueSnackbar("Call failed. Please try again.", {
          variant: "error",
          autoHideDuration: 5000,
        });
        // Don't leave the terminal text on-screen to bleed into the next dial.
        setTimeout(() => setCallStatus(""), 4000);
        return;
      }
    }

    // =========================
    //  TWILIO FLOW (ONLY)
    // =========================
    if (provider === "Twilio") {
      if (!device) {
        console.error("Twilio device not initialized");
        setCallStatus("Device not ready");
        return;
      }

      try {
        setCallDuration(0);

        const params = {
          To: to,
          Direction: direction,
          CallerName: callerName,
          From: user_id,
        };

        const connection = await device.connect({ params });

        if (!connection) return;

        dispatch(setDialOpen(false));
        dispatch(setCallOpen(false));

        setCallStatus("Calling...");
        setActiveConnection(connection);
        setIsCallActive(true);

        connection.on("ringing", () => {
          setCallStatus("Ringing...");
        });

        connection.on("connect", () => {
          setCallStatus("Connected");
        });

        connection.on("disconnect", () => {
          cleanupSingleCallState();
        });

        connection.on("error", (error) => {
          console.error("Twilio error:", error);
          cleanupSingleCallState();
        });
      } catch (err) {
        console.error("Twilio call failed:", err);
        cleanupSingleCallState();
      }

      return;
    }

    // =========================
    // ❌ INVALID PROVIDER
    // =========================
    console.error("Invalid call provider selected");
  };

  // Conference Call For Add Participant inapp Call Function is here

  const [deviceConferenceCall, setDeviceConferenceCall] = React.useState(null);

  const fetchTwilioTokenConferenceCall = async (user_id) => {
    try {
      const response = await getTwilioUserToken(user_id);
      const token = response.data.token;
      const newDevice = new Device(token, {
        codecPreferences: ["opus", "pcmu"],
        fakeLocalDTMF: true,
        enableRingingState: true,
        debug: true,
      });
      setDeviceConferenceCall(newDevice);
      const handleError = (error) => {
        if (error.message.includes("Requested device not found")) {
          openNoDeviceModal({
            title: "Message Status",
            message: "Microphone not found, kindly connect your device.",
            buttonText: "Close",
          });
        } else {
          console.error(`Twilio.Device Error: ${error.message}`);
        }
      };

      const handleIncoming = (conn) => {
        const fromUserId = conn.parameters.From;
        setIncomingCall(conn);
        dispatch(setCaller(fromUserId));

        conn.on("accept", () => {
          setCallAccepted(true);
          setCallDuration(0);
          setIncomingCall(null);
          setActiveConnection(conn);
          setIsCallActive(true);
          dispatch(setAudioCallStart(true));
          navigate("/chats");
        });
      };

      const handleDisconnect = async (con) => {
        if (con) {
          setCallEnded(true);
          const userLoginId = localStorage.getItem("user_id");
          const resp = await getMissedCallCount(userLoginId);
          if (resp?.status == 200) {
            dispatch(setMissedCallCount(resp?.data?.count));
            dispatch(
              setMissedCallParticipantId(
                resp?.data?.result
                  ?.map((data) => data?.cp?.callParticipantId)
                  ?.toString(),
              ),
            );
          }
          dispatch(setUserBusyModel(true));
          setUserOffline(false);
          setActiveConnection(null);
          setIncomingCall(null);
          setCallAccepted(false);
          dispatch(setClearIncomingCall(true));
          setIsCallActive(false);
          dispatch(setAudioCallStart(false));
          dispatch(setCallRunningInBG(false));
          dispatch(setShowChatSectionDuringCall(false));
          dispatch(setIsReceiveMuted([]));
          dispatch(setIsMuted(false));
          setCallDuration(0);
          setCallStatus("");
          navigate("/chats");
        }
      };
      // newDevice.on("ready", handleReady);
      newDevice.on("error", handleError);
      newDevice.on("incoming", handleIncoming);
      newDevice.on("disconnect", handleDisconnect);
    } catch (error) {
      console.error("Error fetching token!");
    }
  };

  useEffect(() => {
    if (user_id) {
      // Fetch token initially
      fetchTwilioTokenConferenceCall(user_id);

      // Set interval for token refresh every 30 minutes
      const interval = setInterval(
        () => {
          fetchTwilioTokenConferenceCall(user_id);
        },
        30 * 60 * 1000,
      );

      return () => clearInterval(interval);
    }
  }, [user_id]);

  const handleDialConferenceCall = async (callerName) => {
    if (deviceConferenceCall) {
      // const params = {
      //   // To: to,
      //   // Direction: direction,
      //   CallerName: callerName,
      //   // From: userID,
      // };
      // console.log(`check conferenceCall--->>`, params);
      const connectionConferenceCall = deviceConferenceCall.connect(callerName);
      if (connectionConferenceCall) {
        // connectionConferenceCall.on("ringing", () => {
        //   console.log(`check conferenceCall ringing`);
        // });
        // connectionConferenceCall.on("disconnect", async () => {
        //   console.log(`check conferenceCall disconnect`);
        // });
        // connectionConferenceCall.on("error", (error) => {
        //   if (error.message.includes("Requested device not found")) {
        //     openNoDeviceModal({
        //       title: "Message Status",
        //       message: "Microphone not found, kindly connect your device.",
        //       buttonText: "Close",
        //     });
        //   } else {
        //     console.error(`Twilio Device Error: ${error.message}`);
        //   }
        // });
      }
    } else {
      console.error("Failed to establish connection.");
    }
  };

  // region Group Calling Function is here

  const handleTrackSubscribed = (track) => {
    if (track.kind === "audio") {
      const audioElement = track.attach();
      document.body.appendChild(audioElement);
    }
  };

  const handleParticipantDisconnected = async (participant) => {
    setLeftParticipants((prev) => [...prev, participant?.identity]);
    setParticipantJoinStatus((prev) => ({
      ...prev,
      [participant?.identity]: {
        ...prev[participant?.identity],
        visible: false,
        joined: false,
      },
    }));

    setAllowedUserIds((prev) =>
      prev.filter((id) => id !== participant?.identity),
    );

    setGCallParticipants((prev) =>
      prev.filter((p) => p?.identity != participant?.identity),
    );

    dispatch(setShowChatSectionDuringCall(false));

    participant.tracks.forEach((publication) => {
      if (publication.track) {
        if (typeof publication.track.detach === "function") {
          publication.track.detach().forEach((element) => element.remove());
        }
        if (publication.track.stop) {
          publication.track.stop();
        }
      }
    });

    const remainingParticipants = groupRoom?.participants?.size || 0;
    if (groupRoom && remainingParticipants <= 1) {
      try {
        if (groupRoom?.state !== "disconnected") {
          groupRoom.disconnect();
        }
      } catch (error) {
        console.error(
          "Error disconnecting room on participant disconnect:",
          error,
        );
      }
      cleanupAfterLeaving();
    } else {
      try {
        const resp = await getUsersById(participant?.identity);
        if (resp?.status === 200) {
          const dataUserName = resp?.data?.result?.[0];
          enqueueSnackbar(
            `${dataUserName?.firstName} ${dataUserName?.lastName} has left the room.`,
            { variant: "warning" },
          );
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    }
  };

  const cleanupAfterLeaving = () => {
    setLeftParticipants([]);
    setGroupRoom(null);
    setGCallParticipants([]);
    setMainParticipant(null);
    setGroupName("");
    setAllowedUserIds([]);
    setGroupPicPath(null);
    setGroupConversationId(null);
    setCallEnded(false);
    setRemoteMutedData(null);
    setPreviousMuteStatus(null);
    dispatch(setIsSendingRoomData([]));
    dispatch(setShowChatSectionDuringCall(false));
    dispatch(setShowChatSectionDuringCall(false));
    dispatch(setAudioCallStart(false));
    dispatch(setCallRunningInBG(false));
    setReconnectingParticipants([]);
    setReconnectingStatus(false);
    setIsCallActive(false);
    if (ringAudioRef.current) {
      ringAudioRef.current.pause();
      ringAudioRef.current.currentTime = 0;
      ringAudioRef.current = null;
    }
    clearCallRecordTimeout();
  };

  const handleJoinAsMainParticipant = async (
    username,
    user_id,
    getGroupData,
    getGroupName,
    GroupPicPath,
    isInitiator,
    groupChat_Id,
    IsParticipate,
  ) => {
    try {
      callRecordAdded.current = false;
      if (groupRoom) {
        await handleRoomDisconnected();
      }
      localStorage.setItem("isInitiatorGCall", JSON.stringify(isInitiator));
      const uniqueRoomName = `${getGroupName}`;
      const userIdentity = `${username}-${user_id}`;
      const response = await getVideoCallToken(user_id, uniqueRoomName);
      const token = response?.data?.token;
      const room = await connect(token, {
        name: uniqueRoomName,
        identity: userIdentity,
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        video: false,
        maxReconnectAttempts: 10,
        maxReconnectTime: 300000,
        networkQuality: {
          local: 3,
          remote: 3,
        },
      });

      if (!room) return;
      const allowedUserIds = getGroupData?.map((item) => {
        return typeof item === "object" && item !== null && "userId" in item
          ? item?.userId.toString()
          : item.toString();
      });

      const ExceptUserIdParticipantData = getGroupData
        ?.filter((item) => {
          const id =
            typeof item === "object" && item !== null && "userId" in item
              ? item.userId.toString()
              : item.toString();
          return id != user_id.toString();
        })
        .map((item) => {
          return typeof item === "object" && item !== null && "userId" in item
            ? item.userId.toString()
            : item.toString();
        });

      const activeGroupRoomData = {
        roomName: getGroupName,
        isCallActive: true,
        participants: allowedUserIds,
      };
      setActiveGroupRooms(activeGroupRoomData);

      localStorage.setItem(
        "activeGroupRooms",
        JSON.stringify(activeGroupRoomData),
      );
      setGroupRoom(room);
      dispatch(setAudioCallStart(true));
      setIsCallActive(true);
      setMainParticipant(user_id);
      setGroupName(getGroupName);
      setAllowedUserIds(allowedUserIds);
      setGroupPicPath(GroupPicPath);
      setGroupConversationId(groupChat_Id);
      setGCallParticipants([]);
      setCallEnded(false);

      const handleNetworkQualityChanged = (participant, level) => {
        if (level <= 1) {
          handleReconnecting(participant);
        } else {
          handleReconnected(participant);
        }
      };

      const emitReconnectingStatus = (status) => {
        SendReconnectingStatus(
          "Group",
          uniqueRoomName,
          parseInt(user_id),
          ExceptUserIdParticipantData,
          status,
        );
      };

      const handleReconnecting = () => {
        setReconnectingStatus(true);
        emitReconnectingStatus(true);
      };

      const handleReconnected = () => {
        setReconnectingStatus(false);
        emitReconnectingStatus(false);
      };

      room.on("reconnecting", () => handleReconnecting());
      room.on("reconnected", () => handleReconnected());

      room.participants.forEach((participant) => {
        if (allowedUserIds.includes(participant?.identity)) {
          handleParticipantConnected(participant, allowedUserIds);
          participant.on("networkQualityLevelChanged", (level) => {
            handleNetworkQualityChanged(participant, level);
          });
          participant.on("reconnecting", () => handleReconnecting());
          participant.on("reconnected", () => handleReconnected());
        }
      });

      room.on("participantConnected", (participant) => {
        if (ringAudioRef.current) {
          ringAudioRef.current.pause();
          ringAudioRef.current.currentTime = 0;
        }
        if (allowedUserIds.includes(participant?.identity)) {
          handleParticipantConnected(participant, allowedUserIds);
          participant.on("networkQualityLevelChanged", (level) => {
            handleNetworkQualityChanged(participant, level);
          });
          room.on("reconnecting", () => handleReconnecting(participant));
          room.on("reconnected", () => handleReconnected(participant));
        }
      });

      room.on("participantDisconnected", (participant) => {
        handleParticipantDisconnected(participant);
      });

      // Add Group Call Record with Invoke Group Call

      if (isInitiator === true) {
        startGroupCall(
          "Group",
          uniqueRoomName,
          user_id,
          allowedUserIds,
          GroupPicPath,
          true,
          false,
        );
        startCallRecordTimeout(
          user_id,
          getGroupName,
          room,
          allowedUserIds,
          groupChat_Id,
        );
      }

      if (IsParticipate === true) {
        console.log(`participants done`);
      }

      return () => {
        room.disconnect();
        cleanupAfterLeaving();
      };
    } catch (error) {
      if (error.message.includes("Requested device not found")) {
        openNoDeviceModal({
          title: "Message Status",
          message: "Microphone not found, kindly connect your device.",
          buttonText: "Close",
        });
      } else {
        console.error(`Error connecting to the room: ${error}`);
      }
    }
  };

  // Add Group Call Record

  const startCallRecordTimeout = (
    user_id,
    getGroupName,
    room,
    allowedUserIds,
    groupChat_Id,
  ) => {
    callRecordTimeout = setTimeout(async () => {
      if (callRecordAdded.current) return;
      // const joinedParticipants = Array.from(joinedParticipantIdsRef.current);
      const joinedParticipants = Array.from(room?.participants.values()).map(
        (p) => p?.identity,
      );
      if (joinedParticipants.length > 1) return;
      if (room && !callRecordAdded.current) {
        callRecordAdded.current = true;
        const callParticipants = allowedUserIds?.map((id) => ({
          userId: parseInt(id),
          joinedAt:
            dayjs(new Date().toISOString()).format("HH:mm:ss.") +
            dayjs(new Date().toISOString())
              .millisecond()
              .toString()
              .padEnd(7, "0"),
          callResponse:
            parseInt(id) === parseInt(user_id) ? "OUTGOING" : "MISSED",
          IsSeen: parseInt(id) === parseInt(user_id) ? true : false,
        }));

        const groupInappPostedData = {
          CallId: 0,
          callType: "Group",
          callTitle: getGroupName,
          CreatedBy: parseInt(user_id),
          STARTTIME:
            dayjs(new Date()).format("HH:mm:ss.") +
            dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
          ENDTIME:
            dayjs(new Date()).format("HH:mm:ss.") +
            dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
          CALLSTATUS: "COMPLETED",
          DURATION: 0,
          ConversationId: groupChat_Id,
          callParticipants,
        };
        if (joinedParticipants?.length === 0) {
          const resp = await addCallRecords(groupInappPostedData);
        }
        setCallEnded(true);
        setActiveGroupRooms({});
      }
    }, 30000);
  };

  const clearCallRecordTimeout = () => {
    if (callRecordTimeout) {
      clearTimeout(callRecordTimeout);
    }
  };

  const handleParticipantConnected = async (participant, allowedUserIds) => {
    if (!allowedUserIds?.includes(participant.identity)) return;

    if (callRecordTimeout) {
      clearTimeout(callRecordTimeout);
      callRecordTimeout = null;
    }
    const isAlreadyConnected = gCallParticipants.some(
      (p) => p?.identity == participant?.identity,
    );

    if (!isAlreadyConnected) {
      // Subscribe to existing and future tracks
      participant.tracks.forEach((publication) => {
        if (publication.isSubscribed) {
          handleTrackSubscribed(publication.track);
        }
      });
      participant.on("trackSubscribed", handleTrackSubscribed);

      // Update participants state
      setGCallParticipants((prev) => {
        if (!prev.some((p) => p?.identity == participant?.identity)) {
          return [...prev, participant];
        }
        return prev;
      });

      // Fetch user information
      try {
        const resp = await getUsersById(participant?.identity);
        if (resp?.status === 200) {
          const dataUserName = resp?.data?.result?.[0];
          if (dataUserName) {
            enqueueSnackbar(
              `${dataUserName?.firstName} ${dataUserName?.lastName} has joined the room`,
              { variant: "info" },
            );
          }
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }

      // Update participants state
      setGCallParticipants((prev) => {
        if (!prev.some((p) => p?.identity == participant?.identity)) {
          return [...prev, participant];
        }
        return prev;
      });
    }
  };

  useEffect(() => {
    if (mainParticipant && groupRoom) {
      createLocalAudioTrack().then((track) => {
        groupRoom.localParticipant.publishTrack(track);
      });
    }
  }, [mainParticipant, groupRoom]);

  // For Muted Group Participants Notification

  useEffect(() => {
    const track = new Video.LocalDataTrack();
    setDataTrack(track);
    if (groupRoom) {
      groupRoom.localParticipant.publishTrack(track);
    }
    groupRoom?.on("trackSubscribed", (track) => {
      if (track.kind === "data") {
        track.on("message", async (message) => {
          const parsedMessage = JSON.parse(message);
          if (parsedMessage?.type === "SCREEN_SHARE_STARTED") {
            setIsScreenShareDisabled(true);
          } else if (parsedMessage?.type === "SCREEN_SHARE_ENDED") {
            setIsScreenShareDisabled(false);
          } else if (parsedMessage?.type === "MUTE_NOTIFICATION") {
            const isMuteChanged = previousMuteStatus != parsedMessage.muted;
            if (isMuteChanged) {
              const resp = await getUsersById(parsedMessage?.id);
              if (resp?.status === 200) {
                const dataUserName = resp?.data?.result?.[0];
                setPreviousMuteStatus(parsedMessage.muted);
                setRemoteMutedData(parsedMessage);
                enqueueSnackbar(
                  `${
                    dataUserName &&
                    dataUserName?.firstName + " " + dataUserName?.lastName
                  } has ${parsedMessage.muted ? "muted" : "unmuted"}.`,
                  { variant: "info" },
                );
              }
            }
          } else if (parsedMessage?.type === "PARTICIPANT_REMOVED") {
            if (parsedMessage?.removedId == user_id) {
              handleRoomDisconnected();
              groupRoom.disconnect();
              enqueueSnackbar("You were removed from the call", {
                variant: "error",
              });
            }
            setGCallParticipants((prev) =>
              prev.filter((p) => p?.identity != parsedMessage?.removedId),
            );
            if (parsedMessage?.senderId != user_id) {
              const resp = await getUsersById(parsedMessage?.removedId);
              if (resp?.status === 200) {
                const removedUser = resp?.data?.result?.[0];
                enqueueSnackbar(
                  `${removedUser?.firstName} ${removedUser?.lastName} was removed from the call`,
                  { variant: "info" },
                );
              }
            }
          } else if (parsedMessage?.type === "NEW_PARTICIPANT_ADDED") {
            // Only process if this isn't our own message
            if (parsedMessage.senderId != user_id) {
              setParticipantJoinStatus((prev) => {
                const newStatus = { ...prev };
                parsedMessage.participantIds.forEach((id) => {
                  if (!newStatus[id]) {
                    newStatus[id] = {
                      joined: false,
                      loading: true,
                      visible: true,
                    };
                  }
                });
                return newStatus;
              });

              setAllowedUserIds((prev) => {
                const newIds = [...prev];
                parsedMessage.participantIds.forEach((id) => {
                  if (!newIds.includes(id)) {
                    newIds.push(id);
                  }
                });
                return newIds;
              });

              // Set timeout to remove if not joined
              parsedMessage.participantIds.forEach((id) => {
                setTimeout(() => {
                  setParticipantJoinStatus((prev) => {
                    if (prev[id] && !prev[id].joined) {
                      return {
                        ...prev,
                        [id]: {
                          ...prev[id],
                          visible: false,
                        },
                      };
                    }
                    return prev;
                  });
                }, 30000);
              });
            }
          }
        });
      }
    });
    return () => {
      if (groupRoom && track) {
        try {
          const isTrackPublished = [
            ...groupRoom.localParticipant.tracks.values(),
          ].some((pub) => pub.track === track);

          if (isTrackPublished) {
            groupRoom.localParticipant.unpublishTrack(track);
          }
          if (track.stop) {
            track.stop();
          }
        } catch (error) {
          console.error("Error during track cleanup:", error);
        }
      }
    };
  }, [groupRoom, previousMuteStatus]);

  // For Adding participant in group call

  useEffect(() => {
    const track = new Video.LocalDataTrack();
    dataTrackRef.current = track;

    if (groupRoom) {
      try {
        groupRoom.localParticipant.publishTrack(track);
      } catch (error) {
        console.error("Error publishing track:", error);
      }
    }

    const handleTrackSubscribed = (track) => {
      if (track.kind === "data") {
        track.on("message", (message) => {
          const data = JSON.parse(message);
          if (data.type === "joinRequest" && data.recipient === user_id) {
            enqueueSnackbar(
              `${data.sender} has invited you to join the group call.`,
              {
                variant: "info",
              },
            );
          }
        });
      }
    };

    if (groupRoom) {
      groupRoom.on("trackSubscribed", handleTrackSubscribed);
    }
    return () => {
      if (groupRoom && dataTrackRef.current) {
        try {
          const isTrackPublished = [
            ...groupRoom.localParticipant.tracks.values(),
          ].some((pub) => pub.track === dataTrackRef.current);

          if (isTrackPublished) {
            groupRoom.localParticipant.unpublishTrack(dataTrackRef.current);
          }
          if (dataTrackRef.current?.stop) {
            dataTrackRef.current.stop();
          }
          dataTrackRef.current = null;
        } catch (err) {
          console.warn("Error during track cleanup:", err);
        }
      }
    };
  }, [groupRoom, user_id]);
  useEffect(() => {
    if (groupRoom) {
      const updatedParticipants = Array.from(groupRoom?.participants.values());
      setGCallParticipants((prev) => {
        const newParticipants = updatedParticipants.filter(
          (participant) =>
            !prev.some((p) => p?.identity == participant?.identity),
        );
        return [...prev, ...newParticipants];
      });
    }
  }, [groupRoom, gCallParticipants]);

  // Participants Disconnected on Remote

  const handleRoomDisconnected = async () => {
    clearCallRecordTimeout();
    dispatch(setShowChatSectionDuringCall(false));
    if (!groupRoom) return;
    enqueueSnackbar(`${loginUserName} has left the room`, {
      variant: "warning",
    });

    // Cleanup local participant's tracks
    groupRoom.localParticipant.tracks.forEach((publication) => {
      if (publication.track) {
        try {
          if (typeof publication.track.stop === "function") {
            publication.track.stop();
          }
          if (typeof publication.track.detach === "function") {
            publication.track.detach().forEach((element) => element.remove());
          }
          groupRoom.localParticipant.unpublishTrack(publication.track);
        } catch (error) {
          console.error("Error cleaning up local participant's track:", error);
        }
      }
    });
    // Cleanup remote participants' tracks
    groupRoom.participants.forEach((participant) => {
      participant.tracks.forEach((publication) => {
        if (publication.track) {
          try {
            if (typeof publication.track.detach === "function") {
              publication.track.detach().forEach((element) => element.remove());
            }
            if (typeof publication.track.stop === "function") {
              publication.track.stop();
            }
          } catch (error) {
            console.error(
              "Error cleaning up remote participant's track:",
              error,
            );
          }
        }
      });
    });

    // Ensure room is fully disconnected
    try {
      if (groupRoom?.state !== "disconnected") {
        groupRoom.disconnect();
      }
    } catch (error) {
      console.error("Error disconnecting the room:", error);
    }

    // Perform complete cleanup
    cleanupAfterLeaving();

    if (mainParticipant === groupRoom.localParticipant.identity) {
      if (groupRoom.participants.size === 0 && !callRecordAdded.current) {
        const joinedParticipants = Array.from(joinedParticipantIdsRef.current);
        GroupCall(groupName, parseInt(user_id), "Group", allowedUserIds, true);
        callRecordAdded.current = true;
        const callParticipants = allowedUserIds?.map((id) => {
          return {
            userId: parseInt(id),
            joinedAt:
              dayjs(new Date().toISOString()).format("HH:mm:ss.") +
              dayjs(new Date().toISOString())
                .millisecond()
                .toString()
                .padEnd(7, "0"),

            callResponse:
              joinedParticipants?.length > 0 &&
              joinedParticipants.includes(id.toString()) &&
              !isInitiatorGCall
                ? "MISSED"
                : parseInt(id) === parseInt(user_id) &&
                    joinedParticipants?.length > 0 &&
                    joinedParticipants.includes(id.toString()) &&
                    !isInitiatorGCall
                  ? "INCOMING"
                  : "OUTGOING",
            IsSeen: true,
          };
        });

        const groupInappPostedData = {
          CallId: 0,
          callType: "Group",
          callTitle: groupName,
          CreatedBy: parseInt(user_id),
          STARTTIME:
            dayjs(new Date()).format("HH:mm:ss.") +
            dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
          ENDTIME:
            dayjs(new Date()).format("HH:mm:ss.") +
            dayjs(new Date()).millisecond().toString().padEnd(7, "0"),
          CALLSTATUS: "COMPLETED",
          DURATION: 0,
          ConversationId: groupConversationId,
          callParticipants,
        };
        const res = await addCallRecords(groupInappPostedData);
        if (res?.data?.result?.callId) {
          newCallLogs(res?.data?.result?.callId);
        }
        setCallEnded(true);
        startGroupCall(
          "Group",
          groupName,
          user_id,
          allowedUserIds,
          groupPicPath,
          false,
          false,
        );
        localStorage.removeItem("isInitiatorGCall");
      }
    }

    // Reset state after room disconnection
    setGroupRoom(null);
    setGCallParticipants([]);
    setMainParticipant(null);
    setGroupName("");
    dispatch(setIsSendingRoomData([]));
    dispatch(setShowChatSectionDuringCall(false));
    dispatch(setAudioCallStart(false));
    dispatch(setCallRunningInBG(false));
    setIsCallActive(false);
    setReconnectingStatus(false);
  };
  useEffect(() => {
    if (groupRoom) {
      groupRoom.on("disconnected", handleRoomDisconnected);
      return () => {
        groupRoom.off("disconnected", handleRoomDisconnected);
      };
    }
  }, [groupRoom]);

  useEffect(() => {
    if (!groupRoom) return;

    const handleParticipantConnected = (participant) => {
      joinedParticipantIdsRef.current.add(participant.identity);
      if (joinedParticipantIdsRef.current.size >= 2) {
        clearCallRecordTimeout();
      }
    };

    groupRoom.on("participantConnected", handleParticipantConnected);

    if (groupRoom.localParticipant) {
      joinedParticipantIdsRef.current.add(groupRoom.localParticipant.identity);
    }

    return () => {
      groupRoom.off("participantConnected", handleParticipantConnected);
    };
  }, [groupRoom]);

  // Group Call Timeout with ringing on background

  useEffect(() => {
    if (groupRoom && mainParticipant) {
      if (
        groupRoom.localParticipant.identity === mainParticipant &&
        groupRoom.participants.size === 0
      ) {
        if (!ringAudioRef.current) {
          ringAudioRef.current = new Audio(outgoingRingtone);
          ringAudioRef.current.loop = true;
          ringAudioRef.current.play();
        }

        const handleParticipantConnected = () => {
          if (ringAudioRef.current) {
            ringAudioRef.current.pause();
            ringAudioRef.current.currentTime = 0;
          }
        };
        const checkParticipants = () => {
          if (groupRoom.participants.size > 0) {
            handleParticipantConnected();
          }
        };

        groupRoom.on("participantConnected", checkParticipants);

        const timeout = setTimeout(() => {
          if (groupRoom.participants.size === 0) {
            enqueueSnackbar("No participants joined. Ending the call.", {
              variant: "warning",
            });

            if (groupRoom?.state !== "disconnected") {
              groupRoom.disconnect();
            }

            cleanupAfterLeaving();
            setCallEnded(true);
            startGroupCall(
              "Group",
              groupName,
              user_id,
              allowedUserIds,
              groupPicPath,
              false,
              false,
            );
          }
        }, 30000);

        return () => {
          clearTimeout(timeout);
          groupRoom.off("participantConnected", checkParticipants);
          handleParticipantConnected();
          if (ringAudioRef.current) {
            ringAudioRef.current.pause();
            ringAudioRef.current.currentTime = 0;
            ringAudioRef.current = null;
          }
        };
      }
    }
  }, [groupRoom, mainParticipant]);

  // For Tab Closes and Refresh the page or crash the page to end group call

  useEffect(() => {
    const handleUnload = () => {
      if (mainParticipant && groupRoom) {
        cleanupAfterLeaving();
        groupRoom.disconnect();
        handleRoomDisconnected();
      }
    };

    window.addEventListener("beforeunload", handleUnload);
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [mainParticipant, groupRoom]);

  // Call End Join Button Ringtone

  React.useEffect(() => {
    if (isGroupCallRingtone === true) {
      audioRef.current = new Audio(groupCallEndRingtone);
      audioRef.current.loop = false;
      audioRef.current
        .play()
        .catch((err) => console.error("Ringtone error:", err));
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
    };
  }, [isGroupCallRingtone, audioRef]);

  return (
    <TwilioContext.Provider
      value={{
        handleDialConferenceCall,
        handleDial,
        noDeviceModal,
        closeNoDeviceModal,
        openNoDeviceModal,
        handleJoinAsMainParticipant,
        handleParticipantDisconnected,
        mainParticipant,
        gCallParticipants,
        groupRoom,
        handleDialForOutboundCall,
        userOffline,
        callDuration,
        setCallDuration,
        callAccepted,
        setCallAccepted,
        activeConnection,
        setActiveConnection,
        incomingCall,
        setIncomingCall,
        callStatus,
        setCallStatus,
        callStartTime,
        setCallStartTime,
        dataTrack,
        setDataTrack,
        remoteMutedData,
        setRemoteMutedData,
        groupName,
        setGCallParticipants,
        chat_Id,
        callEnded,
        setCallEnded,
        handleRoomDisconnected,
        groupPicPath,
        allowedUserIds,
        setCallLogsCallId,
        isScreenShareDisabled,
        setAllowedUserIds,
        participantJoinStatus,
        setParticipantJoinStatus,
        isGroupCallMuted,
        setIsGroupCallMuted,
        leftParticipants,
        activeGroupRooms,
        setActiveGroupRooms,
        setIsGroupCallRingtone,
        reconnectingStatus,
        setReconnectingStatus,
        reconnectingParticipants,
        setReconnectingParticipants,
        setLeftParticipants,
      }}
    >
      {children}
    </TwilioContext.Provider>
  );
};

export const useTwilio = () => useContext(TwilioContext);
